/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Form from "react-bootstrap/Form";
import Axios from "axios";
import Logo from "../img/Logo.png";
import "../index.css";
import bg from "../img/bg.png";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FaExclamationCircle } from "react-icons/fa";
import LineOA from "../components/LineOA";
import jwt from "jsonwebtoken";
import { useSearchParams } from "react-router-dom";

const PageLogin = () => {
  const [Email, setEmail] = useState("");
  const [Values, setValues] = useState({
    otp: ["", "", "", "", "", ""],
  });
  
  const handleOTPChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const newOTP = [...Values.otp];
    newOTP[index] = value;
    setValues({ ...Values, otp: newOTP });

    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`)?.focus();
    }
  };

  const handleOTPKeyDown = (index, e) => {
    if (e.key === "Backspace" && !Values.otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`)?.focus();
    }
  };

  const handleOTPPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasted) return;
    const newOTP = ["", "", "", "", "", ""];
    pasted.split("").forEach((digit, i) => {
      newOTP[i] = digit;
    });
    setValues({ ...Values, otp: newOTP });
    const focusIndex = Math.min(pasted.length, 5);
    document.getElementById(`otp-input-${focusIndex}`)?.focus();
  };
  const Navigate = useNavigate();

  const [isSubmit, setIsSubmit] = useState(false);

  const [searchParams] = useSearchParams();
  const ref = searchParams.get("ref");
  const refToken = searchParams.get("ref_token");
  const navigate = useNavigate();

  const clearAppCache = async () => {
    try {
      if (window.caches && typeof caches.keys === "function") {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
      if (navigator.serviceWorker && typeof navigator.serviceWorker.getRegistrations === "function") {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
      if (window.sessionStorage) {
        sessionStorage.clear();
      }
    } catch (e) {
      console.warn("Cache clear failed:", e);
    }
  };



  const handleSubmit = async (event) => {
    setIsSubmit(true);
    event.preventDefault();
    
    const otpCode = Values.otp.join("");
    if (otpCode.length !== 6) {
      Swal.fire({
        icon: "warning",
        title: "กรุณากรอก OTP 6 หลัก",
        text: "กรุณาตรวจสอบและกรอก OTP ให้ครบถ้วน",
      });
      setIsSubmit(false);
      return;
    }
    
    const checkusername = Email.split("@")[0];
    const data = {
      username: checkusername,
      password: otpCode,
    };

    if (!isSubmit) {
      await Axios.post(process.env.REACT_APP_API_LOGIN, data)
        .then((res) => {
          const result = JSON.parse(JSON.stringify(res.data));
          const {
            age,
            air_worker,
            image,
            mobile_phone,
            office_phone,
            sex,
            ...user_login
          } = result;
          const encodedToken = jwt.sign(user_login, process.env.REACT_APP_JWT, {
            expiresIn: "1d",
          });
          localStorage.setItem("Token_", encodedToken);//me
          localStorage.setItem("Token", result.token);//api
          // localStorage.setItem("id", result.id);
          setIsSubmit(false);
          clearAppCache().finally(() => {
            Navigate("/PageHome");
            setTimeout(() => {
              // ensure fresh assets after SW/unregister
              window.location.reload();
            }, 0);
          });
        })
        .catch((err) => {
          console.log("Error: ", err.response?.data || err.message);
          setIsSubmit(false);
          const errorData = err.response?.data || {};
          const { non_field_errors, username, password, otp } = errorData;
          const isNetworkError = !err.response;
          Swal.fire({
            icon: "error",
            title:
              non_field_errors ||
              username ||
              password ||
              otp ||
              (isNetworkError
                ? "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้"
                : "เข้าสู่ระบบไม่สำเร็จ"),
            text: isNetworkError
              ? "อาจติดปัญหา CORS หรือเครือข่าย กรุณาลองใหม่ภายหลัง"
              : "กรุณากรอกข้อมูลเพื่อเข้าสู่ระบบใหม่",
          });
        });
    }
  };


  const [currentBrowser, setCurrentBrowser] = useState("");

  function getBrowser() {
    let currentBrowser = "";
    if (navigator.userAgent.indexOf("Firefox") !== -1) {
      currentBrowser = "Firefox";
    } else if (navigator.userAgent.indexOf("Edg") !== -1) {
      currentBrowser = "Edge";
    } else if (navigator.userAgent.indexOf("LINE") !== -1) {
      currentBrowser = "LINE";
    }
    // else if (navigator.userAgent.indexOf('LINE') !== -1) { currentBrowser = false; }
    else if (navigator.userAgent.indexOf("Line") !== -1) {
      currentBrowser = "LINE";
    } else if (navigator.userAgent.indexOf("XiaoMi/MiuiBrowser") !== -1) {
      currentBrowser = "Mi";
    } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
      currentBrowser = "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") !== -1) {
      currentBrowser = "Safari";
    } else {
      currentBrowser = "unknown";
    }
    return currentBrowser;
  }

  useEffect(() => {
    detectBrowser();
    const handleLogin = async () => {
       if (refToken) {
        try {
          const data = {
            username: "super-app-salt-auth",
            password: refToken
          };
          // console.log("=============================================");
          // console.log("refToken", refToken);
          // console.log(process.env.REACT_APP_API_LOGIN);
          // console.log("=============================================");
          await Axios.post(process.env.REACT_APP_API_LOGIN, data)
            .then((res) => {
              const result = res.data;
              const {
                age,
                air_worker,
                image,
                mobile_phone,
                office_phone,
                sex,
                ...user_login
              } = result;

              const encodedToken = jwt.sign(user_login, process.env.REACT_APP_JWT, {
                expiresIn: "1d",
              });
              localStorage.setItem("Token_", encodedToken);
              localStorage.setItem("Token", result.token);
              // console.log("++++++++++++++++++++++++++++++++");
              // console.log(result); 
              setIsSubmit(false);
              clearAppCache().finally(() => {
                Navigate("/PageHome");
                setTimeout(() => {
                  window.location.reload();
                }, 0);
              });
            })
            .catch((error) => {
              console.error("Login with ref_token failed:", error);
            });
        } catch (error) {
          console.error("Error with ref_token:", error);
        }
      }
      // Then handle original ref case if no ref_token
      else if (ref) {
        // console.log("Encoded ref:", ref);

        try {
          const decodedRef = atob(ref);
          // console.log("Decoded ref:", decodedRef);

          const parts = decodedRef.split(":");

          if (parts[0] && parts[1]) {
            const username = parts[0];
            const password = parts[1];

            const data = { username, password };

            await Axios.post(process.env.REACT_APP_API_LOGIN, data)
              .then((res) => {
                // console.log('res',res.data)
                const result = res.data;
                const {
                  age,
                  air_worker,
                  image,
                  mobile_phone,
                  office_phone,
                  sex,
                  ...user_login
                } = result;

                const encodedToken = jwt.sign(user_login, process.env.REACT_APP_JWT, {
                  expiresIn: "1d",
                });
                localStorage.setItem("Token_", encodedToken);
                localStorage.setItem("Token", result.token);

                setIsSubmit(false);
                clearAppCache().finally(() => {
                  Navigate("/PageHome");
                  setTimeout(() => {
                    window.location.reload();
                  }, 0);
                });
              })
              .catch((error) => {
                console.error("Login failed:", error);
              });
          } else {
            // console.log("Decoded ref does not contain a ':' separator or is incomplete.");
          }
        } catch (error) {
          console.error("Failed to decode ref:", error);
        }
      } else {
        // console.log("No ref parameter provided.");
        // navigate(
        //   "/notfound404"
        // );
      }
    };

    handleLogin();
  }, [ref, Navigate]);

  const detectBrowser = () => {
    if (
      getBrowser() === "Firefox" ||
      getBrowser() === "Edge" ||
      getBrowser() === "Chrome" ||
      getBrowser() === "Safari"
    ) {
      setCurrentBrowser("succeed");
    } else if (
      getBrowser() === "LINE" ||
      getBrowser() === "Mi" ||
      getBrowser() === "unknown"
    ) {
      setCurrentBrowser("unsuccessful");
    }
  };

  const handleCopyClick = async () => {
    try {
      const tempInput = document.createElement("input");
      tempInput.value = process.env.REACT_APP_API_URLPAGE;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    } catch (err) {
      console.error("Unable to copy URL to clipboard", err);
    }
  };

  const showOTPHowto = () => {
    const base = process.env.PUBLIC_URL || "";
    const zoomImage = (src, alt) => {
      Swal.fire({
        title: alt,
        html: `<img class="otp-zoom-img" src="${src}" alt="${alt}" />`,
        width: 340,
        showConfirmButton: true,
        confirmButtonText: "ปิด",
        confirmButtonColor: "#003481",
        customClass: {
          popup: "otp-howto-popup otp-zoom-popup",
          title: "otp-howto-title",
          confirmButton: "otp-howto-btn",
        },
      }).then(() => {
        showOTPHowto();
      });
    };

    Swal.fire({
      title: "วิธีการรับรหัส OTP",
      html: `
        <p class="otp-howto-subtitle">ใช้รหัสจากแอป RTAF Super App ตามลำดับด้านล่าง</p>
        <div class="otp-howto-row">
          <button type="button" class="otp-howto-item" data-otp-img="${base}/otp2.png" data-otp-alt="ขั้นตอนที่ 1 · เปิดเมนูเพิ่มเติม">
            <span class="otp-howto-step"><span class="otp-howto-step-num">1</span> เปิดเมนูเพิ่มเติม</span>
            <span class="otp-howto-frame">
              <img src="${base}/otp2.png" alt="ขั้นตอนที่ 1" />
            </span>
            <span class="otp-howto-zoom-hint">แตะเพื่อซูม</span>
          </button>
          <div class="otp-howto-arrow" aria-hidden="true">→</div>
          <button type="button" class="otp-howto-item" data-otp-img="${base}/otp1.png" data-otp-alt="ขั้นตอนที่ 2 · ดูรหัส OTP">
            <span class="otp-howto-step"><span class="otp-howto-step-num">2</span> ดูรหัส OTP</span>
            <span class="otp-howto-frame">
              <img src="${base}/otp1.png" alt="ขั้นตอนที่ 2" />
            </span>
            <span class="otp-howto-zoom-hint">แตะเพื่อซูม</span>
          </button>
        </div>
      `,
      width: Math.min(window.innerWidth - 20, 560),
      confirmButtonText: "ปิด",
      confirmButtonColor: "#003481",
      customClass: {
        popup: "otp-howto-popup",
        title: "otp-howto-title",
        confirmButton: "otp-howto-btn",
        htmlContainer: "otp-howto-html",
      },
      didOpen: () => {
        document.querySelectorAll(".otp-howto-item").forEach((btn) => {
          btn.addEventListener("click", () => {
            zoomImage(btn.getAttribute("data-otp-img"), btn.getAttribute("data-otp-alt"));
          });
        });
      },
    });
  };
  return (
    <>
      <style>
        {`
        .my-swal-close {
          font-size: 24px;
        }
        .my-swal-popup {
          padding: 0;
          width: 480px;
          height: 90px;
        }
        .otp-label {
          color: #2c3e50;
          font-weight: 600;
          font-size: 14px;
        }
        .login-input,
        .otp-input {
          border-radius: 14px;
          border: 1px solid #ced4da;
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .login-input {
          min-height: 50px;
        }
        .login-input:focus,
        .otp-input:focus {
          border-color: #5887CB;
          box-shadow: 0 0 0 0.2rem rgba(88, 135, 203, 0.18);
          outline: none;
        }
        .otp-row {
          display: flex;
          width: 100%;
          max-width: 100%;
          gap: 0.5rem;
          box-sizing: border-box;
        }
        .otp-input {
          flex: 1 1 0;
          min-width: 0;
          width: 0;
          max-width: none;
          height: 50px;
          padding: 0;
          font-size: 22px;
          text-align: center;
          font-weight: 700;
          box-sizing: border-box;
        }
        .otp-desc {
          color: #6c757d;
          font-size: 0.95rem;
          padding-top: 6px;
        }
        .otp-howto-link {
          color: #003481;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
          white-space: nowrap;
        }
        .otp-howto-link:hover {
          color: #5887CB;
        }
        .otp-howto-popup {
          border-radius: 16px !important;
          padding: 1.25rem 1rem 1rem !important;
          box-shadow: 0 12px 32px rgba(0, 52, 129, 0.18) !important;
        }
        .otp-howto-title {
          color: #003481 !important;
          font-size: 1.15rem !important;
          font-weight: 700 !important;
          margin-bottom: 0.25rem !important;
        }
        .otp-howto-html {
          margin: 0 !important;
          padding: 0 !important;
        }
        .otp-howto-subtitle {
          margin: 0 0 14px;
          color: #6c757d;
          font-size: 13px;
          line-height: 1.4;
        }
        .otp-howto-row {
          display: flex;
          flex-direction: row;
          gap: 8px;
          align-items: stretch;
          justify-content: center;
        }
        .otp-howto-arrow {
          display: flex;
          align-items: center;
          color: #5887CB;
          font-size: 18px;
          font-weight: 700;
          padding-top: 22px;
          flex: 0 0 auto;
        }
        .otp-howto-item {
          flex: 1 1 0;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 10px;
          border: 1px solid #d5dde8;
          border-radius: 14px;
          background: linear-gradient(180deg, #f7f9fc 0%, #ffffff 100%);
          box-shadow: 0 4px 14px rgba(28, 55, 90, 0.06);
          cursor: zoom-in;
          text-align: center;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .otp-howto-item:hover {
          border-color: #5887CB;
          box-shadow: 0 6px 18px rgba(88, 135, 203, 0.2);
        }
        .otp-howto-step {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          font-size: 12px;
          font-weight: 600;
          color: #2c3e50;
          line-height: 1.3;
        }
        .otp-howto-step-num {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #003481;
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          flex-shrink: 0;
        }
        .otp-howto-frame {
          display: block;
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid #e3e8f0;
          background: #fff;
        }
        .otp-howto-item img,
        .otp-zoom-img {
          width: 100%;
          display: block;
        }
        .otp-zoom-img {
          max-width: 260px;
          margin: 0 auto;
          border-radius: 10px;
          border: 1px solid #e3e8f0;
        }
        .otp-howto-zoom-hint {
          font-size: 11px;
          color: #5887CB;
          font-weight: 500;
        }
        .otp-howto-btn {
          border-radius: 10px !important;
          padding: 0.55rem 1.75rem !important;
          font-weight: 600 !important;
        }
        .otp-zoom-popup {
          width: 320px !important;
        }
        @media (max-width: 480px) {
          .otp-howto-arrow {
            display: none;
          }
          .otp-howto-item {
            padding: 8px;
          }
          .otp-howto-step {
            font-size: 11px;
          }
        }
        @media (max-width: 576px) {
          .otp-input {
            height: 48px;
            font-size: 18px;
          }
          .otp-row {
            gap: 0.35rem;
          }
        }
      `}
      </style>

      {currentBrowser === "unsuccessful" ? (
        <div className="App login-box">
          <section
            style={{
              backgroundImage: `url(${bg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
            }}
          >
            <div className="container min-vh-100 d-flex flex-column align-items-center justify-content-center py-4 ">
              <div className="row justify-content-center ">
                <div className="col-xl-7 col-lg-7 col-md-10 d-flex flex-column align-items-center justify-content-center ">
                  <div className="mb-3">
                    <div
                      className="card-body text-center"
                      style={{ border: "1px solid" }}
                    >
                      <div className="mt-2">
                        <FaExclamationCircle color="yellow" size={70} />
                        <p
                          className="mt-4"
                          style={{ fontSize: "18px", color: "black" }}
                        >
                          ไม่รองรับการแสดงผลบน Appication นี้ กรุณาเปิดบน
                          Browser Chrome หรือ Safari เท่านั้น <br />
                          กรุณาคลิกปุ่มคัดลอกลิงค์ แล้วนำไปวางบน Browser Chrome
                          หรือ Safari{" "}
                        </p>
                        <button
                          className="btn btn-primary w-50"
                          type="button"
                          onClick={handleCopyClick}
                        >
                          คัดลอกลิงค์
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      ) : (
        <Form>
          <div className="App login-box">
            <section
              style={{
                backgroundImage: `url(${bg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
              }}
            >
              <div className="container min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                <div className="row justify-content-center ">
                  <div className="col-xl-5 col-lg-5 col-md-10 d-flex flex-column align-items-center justify-content-center">
                    <div className="mb-3">
                      <div className="card-body">
                        <div className="pt-4 pb-4 text-center ">
                          <img
                            src={Logo}
                            className="ps-3 pe-3 pb-3 figure-img img-fluid rounded"
                            alt="logo"
                          />
                          <b className="card-title fs-4 fw-bold">
                            ระบบทดสอบสมรรถภาพทางกาย
                          </b>
                          <div></div>
                          <b className="card-title fs-4 fw-bold">
                            กำลังพลทหารอากาศ
                          </b>
                          {/* {getBrowser(currentBrowser)} */}
                        </div>
                        <div className="row g-3 needs-validation">
                          <div className="col-12">
                            <label className="form-label mb-2 otp-label">
                              Email RTAF
                            </label>
                            <input
                              id="loginName"
                              placeholder="Email"
                              className="form-control login-input"
                              name="email"
                              type="email"
                              autoComplete="username"
                              onChange={(event) => {
                                setEmail(event.target.value);
                              }}
                            />
                          </div>

                          <div className="col-12">
                            <label className="form-label mb-2 otp-label">
                              OTP (6 หลัก)
                            </label>
                            <div className="otp-row">
                              {Values.otp.map((digit, index) => (
                                <input
                                  key={index}
                                  id={`otp-input-${index}`}
                                  type="text"
                                  inputMode="numeric"
                                  autoComplete={index === 0 ? "one-time-code" : "off"}
                                  maxLength="1"
                                  value={digit}
                                  onChange={(e) => handleOTPChange(index, e.target.value)}
                                  onKeyDown={(e) => handleOTPKeyDown(index, e)}
                                  onPaste={handleOTPPaste}
                                  className="form-control otp-input"
                                  placeholder="-"
                                />
                              ))}
                            </div>
                          </div>
                          <div className="col-12 text-center otp-desc">
                            ใช้รหัส OTP จากระบบยืนยันตัวตน ทอ.{" "}
                            <span
                              className="otp-howto-link"
                              role="button"
                              tabIndex={0}
                              onClick={showOTPHowto}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault();
                                  showOTPHowto();
                                }
                              }}
                            >
                              วิธีการรับรหัส OTP
                            </span>
                          </div>
                          <div className="col-12">
                            <button
                              className="btn btn-primary w-100" style={{ fontSize: "16px" }}
                              type="submit"
                              onClick={handleSubmit}
                            >
                              Login
                            </button>
                            {/* <a
                              className="btn btn-primary w-100 mt-3"
                              href="https://www.youtube.com/watch?v=uKPTslkosUo"
                              style={{
                                fontSize: "13px",
                                border: "none",
                                backgroundColor: "#5887CB",
                              }}
                              target="_blank"
                            >
                              <span>วิดีโอแนะนำการทดสอบสมรรถภาพทางกาย </span>
                              <span
                                className="btn-blink"
                                style={{ fontWeight: "bold" }}
                              >
                                คลิก!
                              </span>
                            </a> */}
                            {/* <div className="mb-3"></div> */}
                            <LineOA />
                            <button
                              className="btn btn-primary w-100 mt-1"
                              style={{
                                fontSize: "13px",
                                height: "35px",
                                border: "none",
                                backgroundColor: "#5887CB",
                              }}
                              onClick={() => window.open("https://www.youtube.com/watch?v=uKPTslkosUo", "_blank")}
                              type="button"
                            >
                              <span>วิดีโอแนะนำการทดสอบสมรรถภาพทางกาย </span>
                              <span
                                className="btn-blink"
                                style={{ fontWeight: "bold", fontSize: "13px" }}
                              >
                                คลิก!
                              </span>
                            </button>

                            {/* <button
                              className="btn btn-primary w-100 mt-1"
                              style={{
                                fontSize: "13px",
                                height: "35px",
                                border: "none",
                                backgroundColor: "#FCCF55",
                                color:"#5E6668"
                              }}
                              onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLScb9Fwy4G0rdExx7-DhnfUkFSK_JtOU5AZVLZWnn-8FHySYWw/viewform", "_blank")}
                              type="button"
                            >
                              <span>แบบสอบถามความพึงพอใจการใช้งานระบบ </span>
                              <span
                                className="btn-blink"
                                style={{ fontWeight: "bold", fontSize: "13px" }}
                              >
                                คลิก!
                              </span>
                            </button> */}

                          </div>
                          <div className="col-12 text-center">
                            <p
                              className="small mb-0"
                              style={{ color: "#F79515", fontSize: "16px" }}
                            >
                              Version 2.0.0
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Form>
      )}
    </>
  );
};

export default PageLogin;
